import { useGlobalState } from "../contexts/GlobalStateContext";

export function DisapproveButton({ post, escalated }) {
  const { removePostWithFade, logOut, resetGlobalState } = useGlobalState();


  const baseUrl = process.env.REACT_APP_BASE_URL;
  // Handle the click for like/unlike
  const disapprovePost = () => {

    const payload = { uuid: post.uuid, escalated: escalated };

    fetch(`${baseUrl}/php/disapprove_post.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
            removePostWithFade(post.uuid);
        } else if (data.status === "error"){
          logOut();
          resetGlobalState();
        } else {
          console.error("Failed to disapprove post:", data.message);
        }
      })
      .catch((error) => {
        console.error("Error during disapproval:", error);
      });
  };

  return (
    <div className="bottom-right" style={{ backgroundColor: "red", padding: "4px 10px" }} onClick={disapprovePost}>
      Dispprove
    </div>
  );
}
